// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-components-layout-js": () => import("./../../../src/components/layout.js" /* webpackChunkName: "component---src-components-layout-js" */)
}

